import Triangles from '@/assets/icons/triangles.svg'
import { getTranslations } from 'next-intl/server'

export const AboutVideo = async () => {
  const t = await getTranslations()
  return (
    <div className='relative'>
      <div className='relative'>
        <video
          autoPlay
          muted
          loop
          playsInline
          preload='metadata'
          poster='/images/fallbacks/about-video-poster.svg'
          aria-label={t('ariaLabels.aboutVideo')}
          className='relative aspect-auto w-full rounded-md object-contain'
        >
          <source
            src={'https://endpoint.flat-lane.com/flatlane_app.mp4'}
            type='video/mp4'
          />
        </video>
        <Triangles className='absolute -bottom-4 left-0 w-10 md:bottom-0 md:w-20' />
      </div>
      <div className='absolute top-0 left-0 z-20 h-full w-full bg-transparent'></div>

      <div className='right-2 bottom-1 pt-6 sm:right-4 md:absolute md:mt-0 md:text-end lg:right-8 lg:bottom-4'>
        <h3 className='text-red text-xl font-bold md:text-3xl'>
          {t('brand.overTheWorld')}
        </h3>
        <p className='text-xs font-medium md:text-xl md:text-white'>
          {t('brand.onTime')}
        </p>
      </div>
    </div>
  )
}
